import { ChangeDetectionStrategy, Component, computed, inject, input, OnInit, Signal } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NODE_EDIT_TAB_COMPONENT, NodeEditTab, SelectedNodeForEdit } from 'src/app/shared/flow-chart/flow-chart.model';
import { VideoNodeData } from '../../../node-edit.type';
import { OnRangeSelectedResult, UiCalendarComponent, UiDatetimeRangePickerModel } from '@ui';
import { UiCalendarPickerType, UIInputStyle } from '@enums/shared.enum';

@Component({
  selector: 'edit-video',
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    UiCalendarComponent,
  ],
  templateUrl: './edit-video.component.html',
  styleUrl: './edit-video.component.scss',
  providers: [
    {
      provide: NODE_EDIT_TAB_COMPONENT,
      useExisting: EditVideoComponent,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditVideoComponent implements OnInit, NodeEditTab {
  public selectedNodeForEdit = input<SelectedNodeForEdit<VideoNodeData>>();
  public disableForm = input<boolean>(false);

  private readonly fb = inject(UntypedFormBuilder);
  private readonly translateService = inject(TranslateService);

  protected readonly uiInputStyles = UIInputStyle; Í

  public dateRangeStartSig: Signal<OnRangeSelectedResult> = computed(() => {
    const start = this.selectedNodeForEdit()?.data?.date;

    return start ? {
      absolute: {
        start: start,
        end: '',
      },
      type: UiCalendarPickerType.ABSOLUTE,
      relative: {
        unit: UiDatetimeRangePickerModel.CustomUnit.minutes,
        value: null,
      },
    } : null;
  })

  public form: UntypedFormGroup = this.fb.group({
    name: [this.translateService.instant('FLOW_CHART.NODES.VIDEO.NAME'), [Validators.required]],
    date: [null, [Validators.required]],
    duration: [null, [Validators.required]],
  })

  public ngOnInit(): void {
    if (this.disableForm()) {
      this.form.disable();
    }

    if (this.selectedNodeForEdit()?.data?.name) {
      this.form.setValue({
        name: this.selectedNodeForEdit().data.name,
        date: this.selectedNodeForEdit().data.date,
        duration: this.selectedNodeForEdit().data.duration,
      })
    }
  }

  public onRangeChange(value: OnRangeSelectedResult): void {
    this.form.patchValue({
      date: value.absolute.start,
    })
  }
}
